import formReducer from '../formsReducer'

const formName = 'orders/customDeadline'

export default formReducer(formName)
